import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaScheduleEvent = styled(Flexbox)(
    ({theme: {typography}}) => css`
        ${typography.textSm};
        cursor: pointer;
    `
)

export const StyledAgendaScheduleEventName = styled.p<{
    $isTentative: boolean
}>(
    ({theme: {palette}, $isTentative}) => css`
        color: ${palette.neutral['950']};
        font-weight: 500;
        text-decoration: ${$isTentative ? 'none' : 'underline'};
    `
)

export const StyledAgendaScheduleEventSubject = styled.p(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['600']};
        font-weight: 400;
    `
)
